import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LogoHeader from '../Assets/food/namkeen_logo_main.png';
import '../Assets/WebsiteCss/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";


function WebHeader() {
    const location = useLocation();
    const [expanded, setExpanded] = useState(false); // Add state
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    const handleNavClick = () => {
        setExpanded(false); // Collapse navbar on link click
    };

    return (
        <>
            {/* Top Contact Navbar */}
            <div className={`top-header ${scrolled || expanded ? 'hide-top' : ''}`}>

                <Container className="d-flex justify-content-between align-items-center">
                    <div className="contact-info">
                        <a
                            href="mailto:info@karigarindia.in"
                            style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                        >
                            <MdMarkEmailRead />
                            <span>info@karigarindia.in</span>
                        </a>

                        <span className='mx-2'>|</span>

                        <a
                            href="https://wa.me/919257781777"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <span><FaPhoneSquareAlt />9257781777</span>
                        </a>
                    </div>
                </Container>
            </div>

            {/* Main Navbar */}
            <Navbar
                expand="lg"
                className={`custom-navbar fixed-top ${scrolled ? 'navbar-top' : ''}`}
                expanded={expanded}
            >
                <Container>
                    <Navbar.Brand as={NavLink} to="/">
                        <img src={LogoHeader} alt="Logo" className="navbar-logo " />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="basic-navbar-nav">

                        {/* Mobile Header inside slide menu */}
                        <div className="mobile-menu-header d-lg-none">
                            <img src={LogoHeader} alt="Logo" className="mobile-logo" />
                            <button className="close-btn" onClick={() => setExpanded(false)}>
                                <FaTimes />
                            </button>
                        </div>

                        <Nav className="mx-auto gap-2 desktop-center-nav">
                            <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>About Us</Nav.Link>
                            <Nav.Link as={NavLink} to="/services" onClick={handleNavClick}>Services</Nav.Link>
                            <Nav.Link as={NavLink} to="/ourproducts" onClick={handleNavClick}>Products</Nav.Link>
                            {/* <Nav.Link as={NavLink} to="/teamandachivements" onClick={handleNavClick}>Our Achievements</Nav.Link> */}
                            <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick}>Contact</Nav.Link>
                        </Nav>

                        <div className="inquiry-btn-wrapper d-none d-lg-flex">
                            <NavLink to="/contact" className="inquiry-btn">
                                Inquiry
                            </NavLink>
                        </div>


                    </Navbar.Collapse>

                </Container>
            </Navbar>
        </>
    );
}

export default WebHeader;